@if ($isOpen()) {
    <div class="cm-dropdown-list">
        <ng-content select="[cm-dropdown]"> </ng-content>
    </div>
}
